import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useAtomValue, useSetAtom } from 'jotai'
import { authenticationState, useAuthentication } from '@repo/unicity'
import { LoadingLayout } from '../layout/loading.layout'
import { userStatusAtom, readStoredUserStatus } from '@/core/auth/user-status.store'

interface AuthGuardProps {
    children: React.ReactNode
}

const AuthGuard = ({ children }: AuthGuardProps) => {
    const authentication = useAtomValue(authenticationState)
    const { restoreSession } = useAuthentication({ enablePersist: true })
    const setUserStatus = useSetAtom(userStatusAtom)
    const navigate = useNavigate()
    const [status, setStatus] = useState<'checking' | 'ok' | 'denied'>('checking')

    useEffect(() => {
        if (authentication.token && authentication.baId) {
            const stored = readStoredUserStatus()
            if (stored) setUserStatus(stored)
            setStatus('ok')
            return
        }

        const restored = restoreSession()
        if (restored) {
            const stored = readStoredUserStatus()
            if (stored) setUserStatus(stored)
            setStatus('ok')
        } else {
            setStatus('denied')
            navigate('/login', { replace: true })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- session restore is a mount-once check; auth atoms/navigate intentionally excluded
    }, [])

    if (status === 'checking') return <LoadingLayout data-testid="auth-guard-loading-layout" />
    if (status === 'denied') return null
    return <>{children}</>
}

export default AuthGuard
